module.exports = __webpack_public_path__ + "img/neya-lisboa-hotel.67e074c3.jpg";